import { Link, useLocation } from "react-router-dom";
import { useAppSelector } from "../../../redux/hooks";
import {
  FaHome,
  FaUserShield,
  FaThList,
  FaTags,
  FaBoxOpen,
  FaShoppingCart,
  FaImage,
  FaNewspaper,
  FaFileAlt,
  FaStar,
  FaTools,
  FaSyncAlt,
} from "react-icons/fa";

const menuItems = [
  { path: "/", label: "Bảng điều khiển", icon: <FaHome /> },
  { path: "/admin", label: "Quản lý admin", icon: <FaUserShield />, superOnly: true },
  { path: "/category", label: "Danh mục", icon: <FaThList /> },
  { path: "/brand", label: "Thương hiệu", icon: <FaTags /> },
  { path: "/product", label: "Sản phẩm", icon: <FaBoxOpen /> },
  { path: "/order", label: "Đơn hàng", icon: <FaShoppingCart /> },
  { path: "/banner", label: "Banner", icon: <FaImage /> },
  { path: "/article", label: "Bài viết", icon: <FaNewspaper /> },
  { path: "/page", label: "Trang", icon: <FaFileAlt /> },
  { path: "/review", label: "Đánh giá", icon: <FaStar /> },
  { path: "/cache", label: "Xóa cache", icon: <FaSyncAlt /> },
];

export const Navbar = () => {
  const location = useLocation();
  const { admin } = useAppSelector((state) => state.admin);
  const isSuperAdmin = admin?.role === "super-admin";

  return (
    <div className="w-full h-screen bg-slate-900 flex flex-col">
      {/* Brand */}
      <div className="px-5 py-6 flex items-center gap-3">
        <div className="w-9 h-9 bg-linear-to-br from-blue-500 to-indigo-600 rounded-lg flex items-center justify-center shrink-0">
          <FaTools className="text-white text-sm" />
        </div>
        <div>
          <p className="text-sm font-bold text-white leading-tight">Thành Phát</p>
          <p className="text-[11px] text-slate-400">Admin Panel</p>
        </div>
      </div>

      {/* Menu */}
      <nav className="flex-1 px-3 py-2 space-y-1 overflow-y-auto scrollbar-hide">
        {menuItems.map((item) => {
          if (item.superOnly && !isSuperAdmin) return null;
          const isActive = location.pathname === item.path;
          return (
            <Link
              key={item.path}
              to={item.path}
              className={`flex items-center gap-3 px-3 py-2.5 rounded-lg text-sm transition-all duration-200 ${
                isActive
                  ? "bg-blue-600 text-white font-medium shadow-lg shadow-blue-600/30"
                  : "text-slate-400 hover:bg-slate-800 hover:text-white"
              }`}
            >
              <span className={`text-base ${isActive ? "text-white" : "text-slate-500"}`}>
                {item.icon}
              </span>
              {item.label}
            </Link>
          );
        })}
      </nav>

      {/* User info */}
      <div className="px-4 py-4 border-t border-slate-800">
        <div className="flex items-center gap-3">
          <div className="w-8 h-8 rounded-full bg-slate-700 flex items-center justify-center">
            <span className="text-xs font-bold text-slate-300">
              {admin?.name?.charAt(0)?.toUpperCase() ?? "A"}
            </span>
          </div>
          <div className="flex-1 min-w-0">
            <p className="text-sm font-medium text-slate-200 truncate">{admin?.name}</p>
            <p className="text-[11px] text-slate-500">
              {admin?.role === "super-admin" ? "Super Admin" : "Admin"}
            </p>
          </div>
        </div>
      </div>
    </div>
  );
};
